import upperFirst from 'lodash/upperFirst';
import groupBy from 'lodash/groupBy';

export const prepareNameProp = (value) => {
  if (!value) {
    return '';
  }
  return upperFirst(`${ value }`.trim());
};

export const groupByProp = (list = [], prop) => groupBy(list, (item) => item[prop]);
